import { useContext } from "react";
import { useIntl } from "react-intl";

import { describeCondition } from "./describeCondition";
import {
  contentCss,
  deleteButtonCss,
  deleteIconCss,
  filtersCss,
  iconCss,
  itemLayoutCss,
  keywordsCss,
  saveFilterSetButtonCss,
} from "./Entry.styles";

import { buildCreateSearchFilterSetPayloadFromSearchHistoryEntry } from "~/client/components/search/hooks/useSaveSearchFilterSet";
import type { SearchHistoryEntry } from "~/client/components/search/hooks/useSearchHistory";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { SearchFilterSetDescription } from "~/client/components/search/SearchFilterSetDescription";
import { buildSearchPathWithParams } from "~/client/components/search/SearchHistory/buildSearchPathWithParams";
import { AppContext } from "~/client/components/shared/AppContext";
import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";
import type { CreateSearchFilterSetInput } from "~/client/generated/schema";

interface Props {
  entry: SearchHistoryEntry;
  isSelected: boolean;
  onSaveFilterSet: (filterSet: CreateSearchFilterSetInput) => void;
  onDelete: (id: string) => any;
}
export const Entry: React.FC<Props> = ({ entry, isSelected, onSaveFilterSet, onDelete }) => {
  const intl = useIntl();

  const saveFilterSetEnabled = useContext(AppContext).betaFeatures.has("save_search_filters");

  const keywords = describeCondition.keywords(intl, entry.keywords);

  const filterSet = buildCreateSearchFilterSetPayloadFromSearchHistoryEntry(entry);

  return (
    <ListItem isSelected={isSelected}>
      <div css={itemLayoutCss}>
        <ListItemLink to={buildSearchPathWithParams(entry.keywords, entry)}>
          <div css={contentCss}>
            <i css={iconCss} className="fa fa-regular fa-clock"></i>
            <span data-testid="keywords" css={keywordsCss}>
              {keywords}
            </span>
            <div data-testid="filters" css={filtersCss}>
              <SearchFilterSetDescription filterSet={entry} />
            </div>
          </div>
        </ListItemLink>
        {saveFilterSetEnabled && entry.hasCustomFilterSet && (
          <button onClick={() => onSaveFilterSet(filterSet)} type="button" css={saveFilterSetButtonCss}>
            {intl.formatMessage({ id: "searchBox.saveSearchFilterSet" })}
          </button>
        )}
        <button
          type="button"
          onClick={() => onDelete(entry.id)}
          css={deleteButtonCss}
          title={intl.formatMessage({ id: "searchBox.deleteSearchHistoryEntry" })}
        >
          <KibelaSymbol id="close" css={deleteIconCss} />
        </button>
      </div>
    </ListItem>
  );
};
